import { render } from "./color-picker.vue?vue&type=template&id=5e90b65a&scoped=true&ts=true"
import script from "./color-picker.vue?vue&type=script&lang=ts"
export * from "./color-picker.vue?vue&type=script&lang=ts"

import "./color-picker.vue?vue&type=style&index=0&id=5e90b65a&lang=scss"
import "./color-picker.vue?vue&type=style&index=1&id=5e90b65a&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\86134\\Desktop\\Web\\Item\\来画设计\\laiiva-web\\packages\\QColor\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e90b65a"]])

export default __exports__